import * as actionType from "./ActionTypes";
import { findIndex, filter } from "lodash";

export default function AddVGMReducers(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.VGM_DATA_LOAD:
      return (state = payload);
    case actionType.ADD_VGM_DATA:
      var finalData = [...state];
      const findId = findIndex(state, (data) => {
        return (
          data.TransporterDataId.toString() ===
          payload.TransporterDataId.toString()
        );
      });
      for (let i = 0; i < state.length; i++) {
        if (
          state[i].TransporterDataId.toString() ===
          payload.TransporterDataId.toString()
        ) {
          finalData[findId] = {
            ...state[i],
            Container_Weight: payload.Container_Weight,
            Container_Mass: payload.Container_Mass,
            Weighing_Date: payload.Weighing_Date,
            Weighing_Slip_No: payload.Weighing_Slip_No,
            Remarks: payload.Remarks,
            VGM_Type: payload.VGM_Type,
            VGMId:payload.VGMId,
            Shipper_Authorised_Name : payload.Shipper_Authorised_Name,
            Mobile_Number : payload.Mobile_Number
          };
        }
      }
      return finalData;
    case actionType.VGM_DELETE_ROW:
      for (let i = 0; i < payload.deleteIdPayload.length; i++) {
        state = filter(state, function (datas) {
          return datas.VGMId !== parseInt(payload.deleteIdPayload[i]);
        });
      }
      // if(state.length === 0){
        payload.statePayload(state)
      // }
      return state;
    default:
      return state;
  }
}
